import styled from 'styled-components';
import { themeColor, themeShadow, themeSize } from '../../../theme/getters';
import { ReactComponent as LogoSVG } from '../../../images/logo.svg';
import { Icon as IconBase, ICON_CROSS } from '../icon';
import { modalHeading } from '../../../theme/typography';
import { media } from '../../../theme/media';

export const Container = styled.div`
  pointer-events: auto;
  background: ${themeColor('primary')};
  padding-left: ${themeSize('contentPadding')}px;
  padding-right: ${themeSize('contentPadding')}px;
  padding-top: 80px;
  padding-bottom: 96px;
  position: relative;
  max-width: 600px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: ${themeSize('contentPadding')}px auto;

  ${themeShadow('primary')};

  ${media.tablet`
    padding-top: 56px;
    padding-bottom: 32px;
  `};
`;

export const LogoImg = styled(LogoSVG)`
  height: 16px;
  fill: ${themeColor('white')};
`;

export const CloseButton = styled.button`
  border: 0;
  width: 40px;
  height: 40px;
  box-shadow: none;
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  cursor: pointer;
`;

export const CloseIcon = styled(IconBase).attrs(() => ({
  stroked: true,
  name: ICON_CROSS,
  size: 40,
}))`
  color: ${themeColor('white')};
  border-color: ${themeColor('white')};
`;

export const Title = styled.h1`
  ${modalHeading};
  margin-top: 8px;
  margin-bottom: 16px;
  color: ${themeColor('white')};
  text-align: center;
`;
